<dx-popup title="Mass result entry"
          [width]="480"
          [height]="200"
          [showTitle]="true"
          [dragEnabled]="true"
          [closeOnOutsideClick]="false"
          [showCloseButton]="false"
          [(visible)]="popupVisible"
          (close)="close()"
          (onHidden)="hidden()"
>
  <dxi-toolbar-item location="after">
    <dx-button text="Close" (click)="close()"></dx-button>
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'content'" style="height: 100%">
    <dx-scroll-view [showScrollbar]="'onScroll'">
      <form [formGroup]="form" style="height: 100%" (submit)="submit()">
        <div class="content-block" fxLayout="column" fxLayoutAlign="space-between stretch">
          <div fxLayout="row" fxFlex fxLayoutAlign="space-between" *ngIf="IsNumeric">
            <div class="dx-field">
              <div class="dx-field-label" style="width: 120px!important">Numeric</div>
              <div class="dx-field-value">
                <dx-text-box [disabled]="!IsNumeric" formControlName="numeric">
                  <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateItem"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlex fxLayoutAlign="space-between" *ngIf="IsTiter">
            <div class="dx-field">
              <div class="dx-field-label" style="width: 120px!important">Titer</div>
              <div class="dx-field-value">
                <dx-text-box formControlName="titer">
                  <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateItem"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlex fxLayoutAlign="space-between" *ngIf="IsAlpha">
            <div class="dx-field">
              <div class="dx-field-label" style="width: 120px!important">Alpha</div>
              <div class="dx-field-value">
                <dx-select-box [items]="getAlphaResults()" formControlName="alpha">
                  <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateItem"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlex fxLayoutAlign="space-between" *ngIf="IsOpen">
            <div class="dx-field">
              <div class="dx-field-label" style="width: 120px!important">Open</div>
              <div class="dx-field-value">
                <dx-text-area formControlName="open">
                  <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateItem"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-area>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="end">
          <div class="dx-fieldset">
            <dx-button text="Submit" [useSubmitBehavior]="true" [disabled]="form.invalid"></dx-button>
          </div>
        </div>
      </form>
    </dx-scroll-view>
  </div>
</dx-popup>
